import {
    Collapse,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import CheckCircleIcon from "@mui/icons-material/CheckCircle";
  import { Box } from "@mui/system";
  import { ExpandLess, ExpandMore } from "@mui/icons-material";
  import { makeStyles } from "@mui/styles";
  
  
  const useStyles = makeStyles((theme) => ({
    editButton: {
      "&:hover": {
        backgroundColor: theme.palette.gif.yellow.hover,
      },
      color: theme.palette.gif.yellow.dark,
      backgroundColor: theme.palette.gif.yellow.color,
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  }));
  
  
  export default function ProgressGroup(props) {
    const { group} = props;
    const classes = useStyles();
    const [errors, setErrors] = useState([]);
    const [openGroups, setOpenGroups] = useState({});
  
    const handleGroupClick = (groupid) => {
      setOpenGroups((prev) => ({ ...prev, [groupid]: !prev[groupid] }));
    };
  
    useEffect(() => {
      const allErrors = group.validations.filter((v) => !v.isValid);
      setErrors(allErrors);
    }, [group]);
  
    return (
      <>
        {errors.length > 0 ? (
          <Box key={group.id}>
            <ListItem button onClick={() => handleGroupClick(group.id)}>
              <ListItemText primary={group.name||"Proposal"} />
              <ListItemIcon />
              {Boolean(openGroups[group.id]) ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse
              in={Boolean(openGroups[group.id])}
              timeout="auto"
              unmountOnExit
            >
              <List component="div" disablePadding>
                {errors.map((error, index) => (
                  <ListItem
                    key={`${group.id}-${index}`}
                    className={classes.nested}
                  >
                    <ListItemText primary={error.errorMessage} />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </Box>
        ) : (
          <ListItem button key={group.id}>
            <ListItemText primary={group.name||"Proposal"} />
            <ListItemIcon>
              <CheckCircleIcon style={{ color: "#00A14B" }} />
            </ListItemIcon>
          </ListItem>
        )}
      </>
    );
  }
  